import { hashKey, useQuery } from '@tanstack/react-query';

import { SortDirection, Transit, TransitGroup, TransitsCriteria } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient, STORAGE_KEYS } from '@utils';
import { getStoredCriteria } from '../../criteria.caching';

interface FetchTransitsResponse {
  list: Transit[];
  total: number;
}

export const defaultCriteria: TransitsCriteria = {
  filters: { filterByUsers: [] },
  pagination: { page: 1, size: 10, direction: 1, searchToken: '', currentToken: '' },
  sorting: { field: 'counter', direction: SortDirection.DESC },
};

export const getInitialCriteria = () => {
  const storedCriteria = getStoredCriteria(STORAGE_KEYS.COOKIES.LIST_TRANSITS_CRITERIA);

  const criteria = storedCriteria ?? defaultCriteria;

  const transitType = criteria.filters.group === TransitGroup.ARRIVAL ? TransitGroup.ARRIVAL : TransitGroup.DEPARTURE;
  criteria.filters.group = transitType;

  return criteria;
};

export const useTransits = (criteria: any) =>
  useQuery({
    queryKey: ['transits', hashKey(criteria)],
    queryFn: async (): Promise<FetchTransitsResponse> => {
      try {
        const result = await apiClient.transit.retrieveTransits.mutation({ body: { criteria } });
        if (result.status !== 200) throw result.body;
        return {
          list: (result.body.data?.list ?? []) as unknown as Transit[],
          total: result.body.data?.totalItems ?? 0,
        };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch transits');
      }
    },
  });
